import { type Currency, currencyKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'

export interface UseCurrencies {
  readonly data: ComputedRef<readonly Currency[]>
  readonly isLoading: ComputedRef<boolean>
}

/** The registry is seed-only (CUR-12/13 in myWealth's spec) - never refetched within a session. */
export function useCurrencies(): UseCurrencies {
  const api = useApi()
  const query = useQuery({
    queryKey: currencyKeys.list(),
    queryFn: ({ signal }) => api.currencies.list(signal),
    staleTime: Infinity,
  })
  return {
    data: computed(() => query.data.value ?? []),
    isLoading: computed(() => query.isPending.value),
  }
}
